module.exports = __webpack_public_path__ + "img/kellyWOO.ce6a774a.png";